import type { InjectionKey } from 'vue';

export const giftcardFactoryChecksumKey = '_gcp_checksum';
export const giftcardFormValidKey = '_giftcardFormValid';

export const NotificationType = {
    ERROR: 'ERROR',
    INFO: 'INFO',
} as const;

export const WoomCookies = {
    WoomSession: 'woomsession',
} as const;

export const HTTPMethod = {
    GET: 'GET',
    PUT: 'PUT',
    POST: 'POST',
    DELETE: 'DELETE',
} as const;

export const woomFoundingDateSring = '2013-03-12';

export const ProductQuantityAvailable = {
    LOW_STOCK: 10,
} as const;

/**
 * `Iwtstns` = "I want to see the new stuff"
 */
export const CACHE_UPDATE_PARAM = 'Iwtstns';

export const bikefinderHeightLimits = {
    lowerMetric: 70,
    upperMetric: 165,
    lowerImperial: 27.6,
    upperImperial: 66,
};
export const bikefinderInseamLimits = {
    lowerMetric: 20,
    upperMetric: 95,
    lowerImperial: 8,
    upperImperial: 40,
};

export const DEFAULT_TITLE = 'Default Title';

// Provide & Inject Symbols
export const VIDEO_ACTIVE_INJECTION_KEY = Symbol() as InjectionKey<Ref<boolean>>;
export const WIDGET_INFO_INJECTION_KEY = Symbol() as InjectionKey<{
    name: string;
    index: number;
}>;
export const SWIPER_SLIDE_INDEX_INJECTION_KEY = Symbol() as InjectionKey<number>;

// TODO: move to /shared/utils/constants after nuxtV4 upgrade
export const TRACEABILITY_KEY = 'frameNumber' as const;
